<template>
    <div class="m-3">
        <vs-button type="border" class="mr-2" to="/grupos/nuevo">Agregar</vs-button>
        <vs-table :data="grupo" search pagination max-items='20'>
            <template slot="header">
                Cantidad: {{grupo.length}}
            </template>
            <template slot="thead">
                <vs-th>Nombre</vs-th>
                <vs-th>Detalle</vs-th>
                <vs-th>Fecha de Creacion</vs-th>
                <vs-th>Acciones</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
    
                    <vs-td :data="tr.nombre">
                        {{tr.nombre}}
                    </vs-td>
    
                    <vs-td :data="tr.detalle">
                        {{tr.detalle}}
                    </vs-td>
    
                    <vs-td :data="tr.fecha_create">
                        {{tr.fecha_create}}
                    </vs-td>
    
                    <vs-td :data="tr.idgrupo">
                        <div class="flex">
                            <vs-button type="border" size="small" icon-pack="feather" icon="icon-edit" class="mr-2" color="dark" @click="getEditar(tr.idgrupo)"></vs-button>
                            <vs-button type="border" size="small" icon-pack="feather" icon="icon-trash" class="mr-2" color="danger" @click="confirmaEliminar(tr.idgrupo)"></vs-button>
                        </div>
                    </vs-td>
    
                </vs-tr>
            </template>
        </vs-table>
    </div>
    </template>
    
    <script>
    import Vue from 'vue'
    import axios from 'axios'
    Vue.use(axios)
    export default {
        data() {
            return {
                grupo: [],
                datoEliminar: '',
            }
        },
        mounted() {
            this.getGrupos();
        },
        methods: {
            getGrupos() {
                let me = this;
                me.$vs.loading();
                me.$http.get(this.$server_url + 'grupo')
                    // axios.get('http://localhost:8000/api/grupo', {
    
                    //     })
                    .then(function (response) {
                        me.grupo = response.data;
                        // console.log(me.grupo);
                        me.$vs.loading.close();
                    })
                    .catch(function () {
                        me.$vs.loading.close();
                    })
            },
            getEditar(idgrupo) {
                this.$router.push('/grupos/editar/' + idgrupo);
                console.log(idgrupo);
            },
            confirmaEliminar(item) {
                let me = this;
                me.datoEliminar = item;
                me.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Confirma eliminar',
                    text: "Seguro desea eliminar este registro",
                    acceptText: 'Si, eliminar',
                    accept: me.getEliminar,
                });
            },
            getEliminar() {
                let me = this;
                me.$vs.loading();
                me.$http.delete(this.$server_url + 'grupo/' + me.datoEliminar)
                    .then(function () {
                        me.getGrupos();
                        me.$vs.notify({
                            color: 'success',
                            text: 'Registro eliminado',
                            iconPack: "feather",
                            icon: "icon-check"
                        });
                        me.$vs.loading.close();
                    })
                    .catch(function () {
                        me.$vs.notify({
                            color: 'danger',
                            text: 'No se ha eliminado el registro',
                            iconPack: "feather",
                            icon: "icon-warning"
                        });
                        me.$vs.loading.close();
                    })
            }
        },
    }
    </script>
    